<script setup lang="ts">
import { RouterLink } from 'vue-router'
import { NXGDSButton, NXGDSButtonVariants, NXGDSButtonSizes } from '@nsftx/seven-nxg-design-system'
import router from '@/router'

const openHelp = (isActive: boolean) => {
  if (isActive) router.back()
  else router.push({ name: 'help' })
}
</script>

<template>
  <div data-cy="helpButtonFooter">
    <RouterLink v-slot="{ isActive }" to="/help" custom>
      <NXGDSButton
        width="56px"
        :variant="NXGDSButtonVariants.secondary"
        :size="NXGDSButtonSizes.big"
        icon="question"
        @click="openHelp(isActive)"
      />
    </RouterLink>
  </div>
</template>
